const FormResources = {

    form_data: {
        associate_id:           '',
        inspection_template_id: '',
        room_id:                '',
        title:                  '',
        date:                   '',
        inspection_report:      false
    },

    form_data_filter: 
    {
        inspection_type_id: '',
        status: false,
        associate_id: '',
        associate_employee_id: '',
        inspection_template_id: '',
        date_range: {},
        needs_correction: '',
        building_id: '',
        level_id: '',
        area_id: '',
        floor_id: '',
        room: '',
        module_name: ''
    },

    form_data_associate_selection: {
        employee_associate_id:           '',
    },

    form_data_template:{
        associate_id:           '',
        room_type_id:           [],
        inspection_template_id: '',
        title:                  '',
        date:                   '',
        room_count:             0,
        random_room:            false,
        inspection_report:      false,
        include_internal_room:  '',
        room_ids:                [],
        omission_setting:       30,
        exclude_rooms: false
    },

    form_data_advanced_search:{
        building_id: '',
        level_id: '',
        area_id: '',
    },

    form_format_advanced_search:[
        {
            css_class:  'col-md-6',
            type:       'select',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Building:',
            model_name: 'building_id',
            ref:        'building_id_input',
            ref_alt:    'building_id_input_alt',
            required:   false,
        },
        {
            css_class:  'col-md-6',
            type:       'select',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Level:',
            model_name: 'level_id',
            ref:        'level_id_input',
            ref_alt:    'level_id_input_alt',
            required:   false,
        },
        {
            css_class:  'col-md-6',
            type:       'select',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Area:',
            model_name: 'area_id',
            ref:        'area_id_input',
            ref_alt:    'area_id_input_alt',
            required:   false,
        },
    ],

    form_format_lite:[
        {
            css_class:  'col-md-12',
            type:       'checkbox',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Send Inpection Report to Associate On Completion:',
            model_name: 'inspection_report',
            ref:        'inspection_report_input',
            ref_alt:    'inspection_report_input_alt',
            required:   false,
        },
        {
            css_class:  'col-md-6',
            type:       'text',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       'Title:',
            model_name: 'title',
            ref:        'title_input',
            ref_alt:    'title_input_alt',
            required:   true,
        },
        {
            css_class:  'col-md-6',
            type:       'select',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Supervisor:',
            model_name: 'associate_id',
            ref:        'associate_id_input',
            ref_alt:    'associate_id_input_alt',
            required:   true,
        },
        {
            css_class:  'col-md-12',
            type:       'date',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Date:',
            model_name: 'date',
            ref:        'date_input',
            ref_alt:    'date_input_alt',
            required:   true,
        },
    ],

    form_format_template:[
        {
            css_class:  'col-md-6',
            type:       'text',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       'Title:',
            model_name: 'title',
            ref:        'title_input',
            ref_alt:    'title_input_alt',
            required:   true,
        },
        {
            css_class:  'col-md-6',
            type:       'select',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Supervisor:',
            model_name: 'associate_id',
            ref:        'associate_id_input',
            ref_alt:    'associate_id_input_alt',
            required:   true,
        },
        {
            css_class:  'col-md-6',
            type:       'date',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Date:',
            model_name: 'date',
            ref:        'date_input',
            ref_alt:    'date_input_alt',
            required:   true,
        },
        {
            css_class:  'col-md-6',
            type:       'select',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Template:',
            model_name: 'inspection_template_id',
            ref:        'inspection_template_id_input',
            ref_alt:    'inspection_template_id_input_alt',
            required:   true,
        },
        {
            css_class:  'col-md-6',
            type:       'infinite-scroll-list',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Room Type:',
            model_name: 'room_type_id',
            ref:        'room_type_id_input',
            ref_alt:    'room_type_id_input_alt',
            required:   true,
            search: false,
            parent_class: 'custom-control custom-checkbox w-100',
            input_type: 'checkbox',
            input_class: 'custom-control-input',
            label_input_class: 'custom-control-label reports__show-hide__label ml-2',
            placeholder: 'Select room type(s)',
            close_on_option: false,
            track_by: 'description'
        },
        {
            css_class:  'col-md-6',
            type:       'number',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       '# Rooms:',
            model_name: 'room_count',
            ref:        'room_count_input',
            ref_alt:    'room_count_input_alt',
            required:   false,
        },
        {
            css_class:  'col-md-12',
            type:       'checkbox',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Send Inpection Report to Associate On Completion:',
            model_name: 'inspection_report',
            ref:        'inspection_report_input',
            ref_alt:    'inspection_report_input_alt',
            required:   false,
        },
        {
            css_class:  'col-md-12',
            type:       'radio',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       '',
            model_name: 'random_room',
            ref:        'random_room_input',
            ref_alt:    'random_room_input_alt',
            required:   false,
            childs: [
                {
                    ref:   'random_room',
                    name:  'Random rooms',
                    value: true,
                },
                {
                    ref:   'all_room',
                    name:  'All rooms',
                    value: false,
                },
            ]
        },
    ],


    form_format4:[
        {
            css_class:  'col-md-3',
            type:       'number',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Rooms omission setting:',
            model_name: 'omission_setting',
            ref:        'omission_setting_input',
            ref_alt:    'omission_setting_input_alt',
            required:   false,
        },
    ],


    form_format:[
        {
            css_class:  'col-md-6',
            type:       'text',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       'Title:',
            model_name: 'title',
            ref:        'title_input',
            ref_alt:    'title_input_alt',
            required:   true,
        },
        {
            css_class:  'col-md-6',
            type:       'select',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Supervisor:',
            model_name: 'associate_id',
            ref:        'associate_id_input',
            ref_alt:    'associate_id_input_alt',
            required:   true,
        },
        {
            css_class:  'col-md-6',
            type:       'date',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Date:',
            model_name: 'date',
            ref:        'date_input',
            ref_alt:    'date_input_alt',
            required:   true,
        },
        {
            css_class:  'col-md-6',
            type:       'infinite-scroll-list',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Room:',
            model_name: 'room_id',
            ref:        'room_id_input',
            ref_alt:    'room_id_input_alt',
            required:   true,
            parent_class: 'custom-control w-100',
            input_type: 'radio',
            input_class: 'custom-radio-list d-inline',
            label_input_class: 'form-check-label radiobutton__text',
            placeholder: 'Select an option',
            close_on_option: true,
            track_by: 'name',
            search: true
        },
        {
            css_class:  'col-md-12',
            type:       'vue-multiselect',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Template:',
            model_name: 'inspection_template_id',
            ref:        'inspection_template_id_input',
            ref_alt:    'inspection_template_id_input_alt',
            required:   true,
            multiple:   false
        },
        {
            css_class:  'col-md-12',
            type:       'checkbox',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Send Inspection Report to Associate On Completion:',
            model_name: 'inspection_report',
            ref:        'inspection_report_input',
            ref_alt:    'inspection_report_input_alt',
            required:   false,
        },
    ],

    form_data2:{
        associate_id:           '',
        inspection_template_id: '',
        room_type_id:           '',
        title:                  '',
        date:                   '',
        room_count:             0,
        random_room:            false,
        inspection_report:      false,
        include_internal_room:  '',
        room_id:                [],
    },

    form_format2:[
        {
            css_class:  'col-md-12',
            type:       'checkbox',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Send Inpection Report to Associate On Completion:',
            model_name: 'inspection_report',
            ref:        'inspection_report_input',
            ref_alt:    'inspection_report_input_alt',
            required:   false,
        },
        {
            css_class:  'col-md-6',
            type:       'text',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       'Title:',
            model_name: 'title',
            ref:        'title_input',
            ref_alt:    'title_input_alt',
            required:   true,
        },
        {
            css_class:  'col-md-6',
            type:       'select',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Supervisor:',
            model_name: 'associate_id',
            ref:        'associate_id_input',
            ref_alt:    'associate_id_input_alt',
            required:   true,
        },
        {
            css_class:  'col-md-6',
            type:       'date',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Date:',
            model_name: 'date',
            ref:        'date_input',
            ref_alt:    'date_input_alt',
            required:   true,
        },
        {
            css_class:  'col-md-6',
            type:       'select',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Template:',
            model_name: 'inspection_template_id',
            ref:        'inspection_template_id_input',
            ref_alt:    'inspection_template_id_input_alt',
            required:   true,
        },
        {
            css_class:  'col-md-6',
            type:       'select',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Room type:',
            model_name: 'room_type_id',
            ref:        'room_type_id_input',
            ref_alt:    'room_type_id_input_alt',
            required:   true,
        },
        {
            css_class:  'col-md-6',
            type:       'number',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       '# Rooms:',
            model_name: 'room_count',
            ref:        'room_count_input',
            ref_alt:    'room_count_input_alt',
            required:   false,
        },
        {
            css_class:  'col-md-12',
            type:       'radio',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       '',
            model_name: 'random_room',
            ref:        'random_room_input',
            ref_alt:    'random_room_input_alt',
            required:   false,
            childs: [
                {
                    ref:   'random_room',
                    name:  'Random rooms',
                    value: true,
                },
                {
                    ref:   'all_room',
                    name:  'All rooms',
                    value: false,
                },
            ]
        },
    ],

    form_format2_light:[
        {
            css_class:  'col-md-12',
            type:       'checkbox',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Send Inpection Report to Associate On Completion:',
            model_name: 'inspection_report',
            ref:        'inspection_report_input',
            ref_alt:    'inspection_report_input_alt',
            required:   false,
        },
        {
            css_class:  'col-md-6',
            type:       'text',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       'Title:',
            model_name: 'title',
            ref:        'title_input',
            ref_alt:    'title_input_alt',
            required:   true,
        },
        {
            css_class:  'col-md-6',
            type:       'select',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Supervisor:',
            model_name: 'associate_id',
            ref:        'associate_id_input',
            ref_alt:    'associate_id_input_alt',
            required:   true,
        },
        {
            css_class:  'col-md-6',
            type:       'date',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Date:',
            model_name: 'date',
            ref:        'date_input',
            ref_alt:    'date_input_alt',
            required:   true,
        },
    ],

    form_data3:{
        associate_id:           '',
        title:                  '',
        date:                   '',
        room_count:             '',
        random_room:            false,
        with_assignment:        false,
        shift:                  '',
        inspection_report:      false,
        room_id:                [],
        daily_assignment_id:    [],
    },

    form_format3:[
        {
            css_class:  'col-md-12',
            type:       'checkbox',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Send Inpection Report to Associate On Completion:',
            model_name: 'inspection_report',
            ref:        'inspection_report_input',
            ref_alt:    'inspection_report_input_alt',
            required:   false,
        },
        {
            css_class:  'col-md-6',
            type:       'text',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       'Title:',
            model_name: 'title',
            ref:        'title_input',
            ref_alt:    'title_input_alt',
            required:   true,
        },
        {
            css_class:  'col-md-6',
            type:       'select',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Supervisor:',
            model_name: 'associate_id',
            ref:        'associate_id_input',
            ref_alt:    'associate_id_input_alt',
            required:   true,
        },
        {
            css_class:  'col-md-6',
            type:       'date',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Date:',
            model_name: 'date',
            ref:        'date_input',
            ref_alt:    'date_input_alt',
            required:   true,
        },
        {
            css_class:  'col-md-6',
            type:       'number',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       '# Rooms:',
            model_name: 'room_count',
            ref:        'room_count_input',
            ref_alt:    'room_count_input_alt',
            required:   false,
        },
        {
            css_class:  'col-md-12',
            type:       'radio',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       '',
            model_name: 'random_room',
            ref:        'random_room_input',
            ref_alt:    'random_room_input_alt',
            required:   false,
            childs: [
                {
                    ref:   'random_room2',
                    name:  'Random rooms',
                    value: true,
                },
                {
                    ref:   'all_room2',
                    name:  'All rooms',
                    value: false,
                },
            ]
        },
        {
            css_class:  'col-md-12',
            type:       'switch',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'View assignments:',
            model_name: 'with_assignment',
            ref:        'with_assignment_input',
            ref_alt:    'with_assignment_input_alt',
            required:   false,
        },
        {
            css_class:  'col-md-4',
            type:       'select',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Shift:',
            model_name: 'shift',
            ref:        'shift_input',
            ref_alt:    'shift_input_alt',
            required:   false,
        },
    ],

    form_format3_light:[
        {
            css_class:  'col-md-12',
            type:       'checkbox',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Send Inpection Report to Associate On Completion:',
            model_name: 'inspection_report',
            ref:        'inspection_report_input',
            ref_alt:    'inspection_report_input_alt',
            required:   false,
        },
        {
            css_class:  'col-md-6',
            type:       'text',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       'Title:',
            model_name: 'title',
            ref:        'title_input',
            ref_alt:    'title_input_alt',
            required:   true,
        },
        {
            css_class:  'col-md-6',
            type:       'select',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Supervisor:',
            model_name: 'associate_id',
            ref:        'associate_id_input',
            ref_alt:    'associate_id_input_alt',
            required:   true,
        },
        {
            css_class:  'col-md-6',
            type:       'date',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Date:',
            model_name: 'date',
            ref:        'date_input',
            ref_alt:    'date_input_alt',
            required:   true,
        },
    ],

    form_format_associate_selection:
    [
        {
            css_class:  'col-md-6',
            type:       'select',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Associate:',
            model_name: 'employee_associate_id',
            ref:        'employee_associate_id_input',
            ref_alt:    'employee_associate_id_input_alt',
            required:   false,
            
        },
    ]
}

export default FormResources;